export default function TitleExperience() {
    return (
        <h1 className="titleExperComp">Mes <span>Expériences</span> Professionnelles</h1>
    );
}